import React from "react";
import { LOGO_URL } from "@/lib/constants";

export default function Logo({ size = 44, className = "" }) {
  return (
    <img
      src={LOGO_URL}
      alt="Dr. Jairo Franco"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      style={{ width: size, height: size, filter: "drop-shadow(0 1px 2px rgba(15,42,67,0.35))" }}
      data-testid="app-logo"
    />
  );
}
